import React from 'react';
import { Container } from 'react-bootstrap';
import '../../../assets/css/customer/contact/ContactHero.css';

const ContactHero = () => {
  return (
    <section className="contact-hero-section">
      <Container>
        <div className="contact-hero-content">
          {/* Main Heading */}
          <h1 className="contact-hero-heading">Contact Us</h1>

          {/* Description */}
          <p className="contact-hero-description">
            Experience elegant wedding planning with smart tools, seamless booking, and personalized recommendations
          </p>
        </div>
      </Container>
    </section>
  );
};

export default ContactHero;